module.exports = __webpack_public_path__ + "media/images/LenovoLogo-POS-Red-af666804cf36badcec336238e4d8c93a.svg";